import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=47c06009&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/about-us.scss?vue&type=style&index=0&id=47c06009&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c06009",
  null
  
)

export default component.exports